import gql from 'graphql-tag'
import { fragAuthorSummary } from '../fragments/author.js'
import { fragPageInfo, fragSeoPostYoastFragment } from '../fragments/seo.js'
import { fragCptAdv } from '../fragments/advertising.js'

export const queryEditorialStaff = gql`
  ${fragAuthorSummary}
  ${fragPageInfo}
  ${fragSeoPostYoastFragment}
  query QueryEditorialStaff(
    $startCursorAuthors: String
    $lastAuthors: Int
    $endCursorAuthors: String
    $firstAuthors: Int = 15
    $uriPage: String
  ) {
    users(
      before: $startCursorAuthors
      last: $lastAuthors
      after: $endCursorAuthors
      first: $firstAuthors
      where: { hasPublishedPosts: POST, nicenameNotIn: "supervisor" }
    ) {
      edges {
        node {
          ...FragAuthorSummary
        }
      }
      pageInfo {
        ...FragPageInfo
      }
    }
    pageBy(uri: $uriPage) {
      campiPagina {
        titoloPagina
        descrizionePagina
      }
      seo {
        ...FragSeoPostYoastFragment
      }
    }
  }
`

export const queryEditorialStaffIntegration = gql`
  ${fragCptAdv}
  ${fragAuthorSummary}
  ${fragPageInfo}
  ${fragSeoPostYoastFragment}
  query QueryEditorialStaffIntegration(
    $startCursorAuthors: String
    $lastAuthors: Int
    $endCursorAuthors: String
    $firstAuthors: Int = 15
    $uriPage: String
  ) {
    users(
      before: $startCursorAuthors
      last: $lastAuthors
      after: $endCursorAuthors
      first: $firstAuthors
      where: { hasPublishedPosts: POST, nicenameNotIn: "supervisor" }
    ) {
      edges {
        node {
          ...FragAuthorSummary
        }
      }
      pageInfo {
        ...FragPageInfo
      }
    }
    pageBy(uri: $uriPage) {
      campiPagina {
        titoloPagina
        descrizionePagina
      }
      seo {
        ...FragSeoPostYoastFragment
      }
      advertising {
        acfAdv {
          ... on Advertising {
            advertisingType {
              cptAdv {
                ...FragCptAdv
              }
            }
          }
        }
      }
    }
  }
`
